import { useRef, useState } from "react";

function ExamCamera() {
  const videoRef = useRef(null);
  const [cameraStarted, setCameraStarted] = useState(false);

  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      setCameraStarted(true);

      // Wait for the video element to be rendered
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      }, 100);

    } catch (err) {
      alert("Camera access denied. You cannot enter the exam! " + err);
    }
  };

  return (
    <div>
      <button onClick={openCamera}>Enter Exam</button>

      {cameraStarted && (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          style={{ width: "300px", border: "2px solid black" }}
        />
      )}
    </div>
  ); 
}

export default ExamCamera;
